import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import Input from '../../../../../FormComponents/Input'
import ReactSelect from '../../../../../FormComponents/ReactSelect'

export default observer(function OverviewOrganic({ values, handleChange, handleBlur, setFieldValue }) {
  const [open, setOpen] = useState(true)
  const { selectedScenario } = useContext(CampaignContext)

  const postOptions = useMemo(() => selectedScenario.actions.map(action => ({ label: `${action.auth_username} - ${action.name}`, value: action.id })), [selectedScenario, selectedScenario.actions, selectedScenario.actions?.length])


  return (
    <div className="mb-8">
      <div className="flex justify-between mt-8">
        <p className="font-bold">Overview - Organic</p>
        <button type="button" onClick={() => setOpen(!open)}>{open ? <ChevronUp /> : <ChevronDown /> }</button>
      </div>
      <div className={`${open ? 'h-[420px]' : 'h-0 overflow-hidden'} transition-all duration-300`}>
        <table className="w-full border-1 border-gray-100 rounded-lg">
          <tbody>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Total Impressions</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <Input
                  topMargin=''
                  name='organic_impressions'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.organic_impressions}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Total Reach</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <Input
                  topMargin=''
                  name='organic_reach'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.organic_reach}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Engagement Rate</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <Input
                  topMargin=''
                  name='organic_engagement_rate'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.organic_engagement_rate}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Top Performing Post(s)</td>
              <td className="p-4 overflow-visible border-1 border-gray-100" colSpan="2">
                <ReactSelect
                  name="organic_top_performing_post_id"
                  onChange={option => setFieldValue('organic_top_performing_post_id', option.value, true)}
                  onBlur={handleBlur}
                  value={values.organic_top_performing_post_id}
                  options={postOptions}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Comment</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <Input
                  topMargin=''
                  name='organic_comment'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.organic_comment}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
})